"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettePropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Kette properties that are used by the individual applications compact requests.
 */
class KettePropertiesCompact {
}
exports.KettePropertiesCompact = KettePropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
KettePropertiesCompact[_a] = [
    'Id',
    'EchainId',
    'AdapterLinkRef',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArtNrUS',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'AutoglideLinkRef',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'EchainSystem',
    'EcpRef',
    'EffektiveLaenge',
    'FreigabeEIQ',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'K2',
    'KetteSerieType',
    'LeitungDiameterMax',
    'MaxCablesPerChamber',
    'ModifiedLinkRef',
    'MontagesetRef',
    'NumFirstOtherLinks',
    'NumGlieder',
    'OpeningPrinciple',
    'RadiusAussen',
    'RinneRef',
    'RinnenvarianteRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SmartPlasticsECWAllowed',
    'StandardLinkRef',
    'Teilung',
];
KettePropertiesCompact[_b] = [
    'Id',
    'EchainId',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArtNrUS',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'Bauform',
    'BelastungFLB',
    'BelastungFLG',
    'BelastungGleitendMaxWeightUntilSpeed',
    'BeschleunigungFLBMax',
    'BeschleunigungFLGMax',
    'BeschleunigungGleitendMax',
    'BeschleunigungHaengendMax',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'D',
    'D1',
    'EchainSystem',
    'EffektiveLaenge',
    'EinbauartFreitragendErlaubt',
    'EinbauartGleitendErlaubt',
    'EinbauartHaengendErlaubt',
    'EinbauartHaengendMax',
    'EinbauartLangeVerfahrwege',
    'FZGleitendMax',
    'FreigabeEIC',
    'FreigabeEKE',
    'FreigabeEKEManualMode',
    'GeschwindigkeitFLBMax',
    'GeschwindigkeitFLGMax',
    'GeschwindigkeitGleitendMax',
    'GeschwindigkeitHaengendMax',
    'GewichtKgProM',
    'GleitenderBetriebErlaubt',
    'H',
    'HoeheVorspannung',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'K',
    'K2',
    'K3',
    'KetteSerieType',
    'LeitungDiameterMax',
    'MaxAELaenge',
    'MaxCablesPerChamber',
    'MinBauraumGleitendRinneRefs',
    'MontagesetRef',
    'NumGlieder',
    'OpeningPrinciple',
    'OpeningPrincipleLabel',
    'PushPullForceMax',
    'RadiusAussen',
    'RinneRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SerienKurzbezeichnung',
    'SmartPlasticsECWAllowed',
    'Teilung',
    'TemperaturMax',
    'TemperaturMin',
    'WidenBildId',
    'WidenZeichnungId',
    'X1',
];
KettePropertiesCompact[_c] = [
    'Id',
    'EchainId',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArtNrUS',
    'ArticleSpecs',
    'ArticleType',
    'Bezeichnung',
    'Biegeradius',
    'ContractedLength',
    'EffektiveLaenge',
    'FreigabeEIC',
    'FreigabeEKE',
    'GewichtKgProM',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'KetteSerieType',
    'MaxCablesPerChamber',
    'NumGlieder',
    'OpeningPrinciple',
    'RadiusAussen',
    'Rotationswinkel',
    'SerieRef',
];
KettePropertiesCompact[_d] = ['Id', 'EchainId'];
//# sourceMappingURL=KettePropertiesCompact.js.map